import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Grid, Input, Modal, Checkbox, Spin, Empty, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import { ApiCaller, Utils } from '../../config';
import { AppAction, GeneralActions, UserManagementAction } from '../../store/actions';
import { Colors } from '../../config';
import { IoIosSearch } from 'react-icons/io';
import { MdGroups } from 'react-icons/md';
import { FaCirclePlus } from "react-icons/fa6";
import { FaBars, FaUserPlus, FaUsers } from 'react-icons/fa';
import { TextField, Button, Pagination } from '../../components';
import useColors from '../../hooks/useColors';
import UserAddnEditDrawer from './UserAddnEditDrawer';
import { useForm } from 'react-hook-form';
import { FaPaperclip, FaPen, FaTrash } from 'react-icons/fa6';
import { IoSend } from 'react-icons/io5';
import { useQuery } from 'react-query';
import { getActiveUsers } from '../../config/getApis';
import useDebounce from '../../config/Hooks/useDebounce';

const ConnectivityHuboard = () => {
    const { colorPrimary } = useColors();
    const scrn = Grid.useBreakpoint();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [chatLoading, setChatLoading] = useState(false);

    const [isUploading, setIsUploading] = useState(false);

    const [error, setError] = useState(null);
    const [mediaID, setMediaID] = useState(null); // Store uploaded image ID

    const [selectedChatId, setSelectedChatId] = useState(null);
    const [chatMessages, setChatMessages] = useState([]);
    const [message, setMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);

    const [startIndex, setStartIndex] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [hubSearchText, setHubSearchText] = useState('');
    const [chatSearchText, setChatSearchText] = useState('');
    const { handleSubmit, control, reset, clearErrors, setValue } = useForm({
        mode: 'onChange',
    });

    const [userToRemove, setUserToRemove] = useState(null);
    // const [readFile, setReadFile] = useState(null);

    const [drawerStates, setDrawerStates] = useState({ openDrawer: false });
    // const [img, setimg] = useState(null);
    const [imageValue, setImageValue] = useState({
        imgSizeValidation: '',
        imgTypeValidation: '',
        isRequired: '',
    });

    const [state, setState] = useState({
        current: 1,
        limit: 20,
        searchVal: '',
        tabName: 'active',
        roleType: '',
    });
    const userData = useSelector(
        (state) => state?.UserManagementReducer?.UserData,
    );
    const myUuser = useSelector((state) => state?.AppReducer?.user);
    const myUserId = myUuser?.id;
    console.log('myUserId:', myUserId);
    const loader = useSelector((state) => state?.UserManagementReducer?.loader);

    // const { data: payload } = useQuery(['users'], () => getActiveUsers({}), {
    //     enabled: drawerStates.typeOfShift === 'normal',
    // });

    const [showModal, setShowModal] = useState(false);
    const [showMembersModal, setShowMembersModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [usersListingLoader, setUsersListingLoader] = useState(false);
    const [addUsersLoading, setAddUserLoading] = useState(false);

    const [filteredUsersState, setFilteredUsersState] = useState([]);
    // filters for searching 
    const [filtersParams, setFiltersParams] = useState({
        search: '',
        page: 1,
        perPage: 10,
        total: 0
    })
    const [refresh, setRefresh] = useState(false);

    const debounceValue = useDebounce(filtersParams?.search, 2000);

    const [fetchChannels, setFetchChannels] = useState(false);

    const [currentChannelUsers, setCurrentChannelUsers] = useState([]);

    // Edit channel state
    const [editChannelModal, setEditChannelModal] = useState(false);
    const [editChannelData, setEditChannelData] = useState(null);
    const [editChannelName, setEditChannelName] = useState('');
    const [editChannelReadFile, setEditChannelReadFile] = useState('');
    const [editChannelMediaID, setEditChannelMediaID] = useState(null);
    const [editChannelIsUploading, setEditChannelIsUploading] = useState(false);
    const [editChannelLoading, setEditChannelLoading] = useState(false);

    // Delete channel state
    const [deleteChannelModal, setDeleteChannelModal] = useState(false);
    const [deleteChannelId, setDeleteChannelId] = useState(null);
    const [deleteChannelLoading, setDeleteChannelLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await ApiCaller.Get('/admin/chat-channels');
                if (Array.isArray(response.data.data)) {
                    setData(response.data.data);
                } else {
                    setError('Invalid response structure');
                }
            } catch (err) {
                if (Utils.isSubscriptionError(err)) {
                    setData([]);
                    Utils.showMessage('error', err?.response?.data?.message);
                } else {
                    setError(err.message);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [fetchChannels])

    useEffect(() => {
        socketRef.current = io(
            `${process.env.REACT_APP_SOCKET_HOST}:${process.env.REACT_APP_SOCKET_PORT}`,
        );

        socketRef.current.on('connect', () => {
            console.log('Socket connected:', socketRef.current.id);
        });

        socketRef.current.on('updateChatChannels', (updatedChannel) => {
            setData((prevData) => {
                const existingIndex = prevData.findIndex(
                    (channel) => channel.id === updatedChannel.id,
                );
                if (existingIndex >= 0) {
                    const updatedData = [...prevData];
                    updatedData[existingIndex] = updatedChannel;
                    return updatedData;
                }
                return [...prevData, updatedChannel];
            });
        });

        socketRef.current.on('disconnect', () => {
            console.log('Socket disconnected');
        });

        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    // useEffect(() => {
    //     // dispatch(UserManagementAction.GetUsers(state)); // Fetching the users when the component mounts
    // }, [dispatch]);

    useEffect(() => {
        if (!selectedChatId) return;

        socketRef.current.emit('joinRoom', {
            room: `chatChannel.${selectedChatId}`,
        });

        socketRef.current.on('chatMessages', (newMessage) => {
            console.log('newMessages', newMessage);
            setChatMessages((prevMessages) => [
                ...prevMessages,
                {
                    messageId: newMessage.id,
                    message: newMessage.message,
                    messageImage: newMessage?.media?.length
                        ? newMessage.media[0].url
                        : '',
                    messageSenderName:
                        newMessage.sender?.id == myUserId ? 'You' : newMessage.sender?.firstName ? newMessage.sender?.firstName : 'Unknown',
                    messageDateTime: newMessage.created_at,
                    userId: newMessage?.sender?.id
                },
            ]);
        });

        return () => {
            socketRef.current.off('chatMessages');
        };
    }, [selectedChatId]);

    // calling an api.
    useEffect(() => {
        if (filtersParams) {
            const fetchusers = async () => {
                try {
                    setUsersListingLoader(true)
                    let { userOptions, resPaginate } = await getActiveUsers(filtersParams);
                    setFilteredUsersState(() => {
                        const alreadyPresentGroupUsers = [...currentChannelUsers];
                        // if user exists on group already.
                        if (alreadyPresentGroupUsers?.length == 0) {
                            return userOptions
                        }
                        // no active user.
                        else if (userOptions?.length == 0) {
                            return []
                        }
                        // filtering out the already present users to show the new users to add now
                        // also filtering out the current login user.
                        else {
                            const existingIds = [...new Set(alreadyPresentGroupUsers?.map(groupUser => groupUser?.member?.id))] || [];
                            return userOptions.filter(user => !existingIds.includes(user.value) && user.value !== myUserId);
                        }
                    });
                    setFiltersParams((prev) => ({ ...prev, total: resPaginate?.total }))
                } catch (error) {
                    console.log(error)
                }
                finally {
                    setUsersListingLoader(false)
                }
            }
            fetchusers()
        }
    }, [refresh, debounceValue])


    const handleButtonClick = (user) => {
        console.log('View details for', user);
        // You can handle user detail view here
    };

    const openDrawer = () => {
        setDrawerStates({ openDrawer: true });
        // Fetch users when the drawer is opened
        dispatch(UserManagementAction.GetUsers(state));
    };

    const onCloseDrawer = () => {
        if (drawerStates?.drawerkey == 1 && drawerStates.userDetailDrawer) {
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: false,
                drawerkey: null,
                userid: null,
            });
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            reset();
        } else {
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: false,
                userid: null,
            });
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            dispatch(UserManagementAction.UserDetailReset());
            reset();
        }
    };

    // Filter users based on search
    // const filteredUsers = usersOptions?.filter((user) =>
    //     `${user.label}`.toLowerCase().includes(searchText.toLowerCase()),
    // );

    const filteredData = searchText
        ? data.filter((group) =>
            group.name?.toLowerCase().includes(searchText.toLowerCase()),
        )
        : data;
    const socketRef = useRef(null);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    };

    useEffect(() => {
        if (!chatLoading) {
            setTimeout(() => {
                scrollToBottom();
            }, 100);
        }
    }, [chatMessages, selectedChatId, chatLoading]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setSelectedFile(file);
        await handleImageUpload(file); // Automatically upload after selection
    };
    const handleDeleteImage = () => {
        setSelectedFile(null);
        setMediaID(null);
    };

    const handleChatClick = async (id) => {
        setSelectedChatId(id);
        dispatch(GeneralActions.SetChatChanneId(id));
        try {
            setChatLoading(true);
            const response = await ApiCaller.Get(`/chat-channel/${id}`);
            console.log("selectedChatResponse", response)
            setCurrentChannelUsers(response?.data?.data?.chatMembers || [])
            const messages = response?.data?.data?.messages || [];
            const sanitizedMessages = messages.map((msg) => ({
                messageSenderName:
                    msg.sender?.id === myUserId
                        ? 'You'
                        : `${msg.sender?.firstName || 'Unknown'} ${msg.sender?.lastName || ''}`.trim(),
                userId: msg.sender?.id,
                message:
                    typeof msg.message === 'string'
                        ? msg.message
                        : JSON.stringify(msg.message),
                messageImage: msg?.media?.length ? msg.media[0].url : '',
                messageDateTime: msg.created_at,
            }));
            setChatMessages(sanitizedMessages);
        } catch (error) {
            console.error('Failed to fetch chat messages:', error);
            setChatMessages([]);
        } finally {
            setChatLoading(false);
        }
    };

    const handleImageUpload = async (file) => {
        if (!file) return;

        let formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'profile'); // Image upload type

        setIsUploading(true); // Show loader

        try {
            const mediaRes = await ApiCaller.Post('/media/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (mediaRes?.data?.status === 200) {
                setMediaID(mediaRes.data.data.id); // Store media ID
            } else {
                console.error(
                    'Failed to upload media:',
                    mediaRes?.data?.message,
                );
            }
        } catch (error) {
            Utils.showMessage('error', error?.response?.data?.message)
            setSelectedFile(null);
        } finally {
            setIsUploading(false); // Hide loader
        }
    };

    const handleMessageSend = async () => {
        console.log('Media ID:', message);

        if (!message.trim() && !mediaID) return; // Ensure either message or image is present

        let messageFormData = new FormData();
        messageFormData.append('type', mediaID ? 'image' : 'text');

        if (mediaID) {
            messageFormData.append('mediaId', mediaID);
        } else {
            messageFormData.append('message', message);
        }

        try {
            const res = await ApiCaller.Post(
                `/chat-channel/${Number(selectedChatId)}/message`,
                messageFormData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                },
                setSelectedFile(''),
                setMessage(''),
            );

            if (res?.data?.status === 201) {
                const newMessage = {
                    // messageId: res.data.data.id,
                    message: mediaID ? null : message,
                    messageSenderName: 'You',
                    messageDateTime: new Date().toISOString(),
                    // messageImage: mediaID ? res.data.data.url : null,
                    // setting id as well to handle the chat display position for the current user.
                    userId: myUserId
                };

                // Emit message via socket
                socketRef.current.emit('sendMessage', {
                    chatId: selectedChatId,
                    message: newMessage.message,
                    group: true,
                    file: newMessage.messageImage,
                });

                // Update chat messages state
                // setChatMessages((prevMessages) => [
                //     ...prevMessages,
                //     newMessage,
                // ]);

                // Reset input fields after successful message send
                reset(message);
                setSelectedFile(null);
                setMediaID(null);

                // **Force UI update for file input**
                const fileInput = document.getElementById('file-input');
                if (fileInput) fileInput.value = ''; // Clears file selection
            } else {
                console.error('Failed to send message:', res?.data?.message);
            }
        } catch (error) {
            console.error('Error while sending message:', error);
        }
    };

    // if (loading) return <p>{loader && <Spin />}</p>;
    if (error) return <p>Error: {error}</p>;
    const handleUserSelection = (userId) => {
        setSelectedUsers((prev) =>
            prev.includes(userId)
                ? prev.filter((id) => id !== userId)
                : [...prev, userId],
        );
    };

    const handleAddUsers = () => {
        const apiUrl = `/admin/chat-channel/${selectedChatId}/members`;

        const payload = {
            userId: selectedUsers,
        };

        setAddUserLoading(true)
        ApiCaller.Post(apiUrl, payload)
            .then((response) => {
                Utils.showMessage('success', response.data.message);
                setShowModal(false);
                setFiltersParams({
                    ...filtersParams,
                    search: '',
                    page: 1,
                    perPage: 10,
                    total: 0
                })
                setSelectedUsers([])
            })
            .catch((error) => {
                Utils.showMessage('error', response.data.message);
            })
            .finally(() => {
                setAddUserLoading(false)
            })

    };

    // Function to handle clicking the sender name
    const handleSenderClick = (msg) => {
        setUserToRemove(msg);
        setShowDeleteModal(true);
    };

    // Function to handle API call to remove member
    const handleRemoveUser = async () => {
        if (userToRemove) {
            console.log('Removing user:', userToRemove.userId);
            try {
                const response = await ApiCaller.Delete(
                    `/admin/chat-channel/${selectedChatId}/member`,
                    { userId: userToRemove?.userId },
                );
                Utils.showMessage('success', response.data.message);
                // Close the modal after successful removal
                setShowDeleteModal(false);
            } catch (error) {
                setShowDeleteModal(false);
                Utils.showMessage('error', error.response.data.message);
            }
        }
    };

    const paginationHandler = (value) => {
        setFiltersParams((prev) => ({ ...prev, page: value }))
        setRefresh(!refresh)
    }

    const handleEditChannelImageUpload = async (file) => {
        if (!file) return;
        let formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'profile');
        setEditChannelIsUploading(true);
        try {
            const mediaRes = await ApiCaller.Post('/media/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (mediaRes?.data?.status === 200) {
                setEditChannelMediaID(mediaRes.data.data.id);
            }
        } catch (error) {
            Utils.showMessage('error', error?.response?.data?.message || 'Image upload failed');
        } finally {
            setEditChannelIsUploading(false);
        }
    };

    const handleEditChannelFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
            Utils.showMessage('error', 'Only png, jpg, jpeg images are allowed');
            return;
        }
        const reader = new FileReader();
        reader.onload = (ev) => setEditChannelReadFile(ev.target.result);
        reader.readAsDataURL(file);
        handleEditChannelImageUpload(file);
    };

    const handleEditChannel = async () => {
        if (!editChannelData?.id) return;
        const payload = {};
        if (editChannelName?.trim()) payload.channelName = editChannelName.trim();
        if (editChannelMediaID) payload.imageId = editChannelMediaID;
        if (!payload.channelName && !payload.imageId) {
            Utils.showMessage('warning', 'Please update the channel name or image');
            return;
        }
        setEditChannelLoading(true);
        try {
            const response = await ApiCaller.Patch(`/admin/chat-channel/${editChannelData.id}`, payload);
            Utils.showMessage('success', response?.data?.message || 'Channel updated successfully');
            setEditChannelModal(false);
            setEditChannelData(null);
            setFetchChannels((prev) => !prev);
        } catch (error) {
            Utils.showMessage('error', error?.response?.data?.message || 'Failed to update channel');
        } finally {
            setEditChannelLoading(false);
        }
    };

    const handleDeleteChannel = async () => {
        if (!deleteChannelId) return;
        setDeleteChannelLoading(true);
        try {
            const response = await ApiCaller.Delete(`/admin/chat-channel/${deleteChannelId}`);
            Utils.showMessage('success', response?.data?.message || 'Channel deleted successfully');
            setDeleteChannelModal(false);
            setDeleteChannelId(null);
            if (selectedChatId === deleteChannelId) {
                setSelectedChatId(null);
                setChatMessages([]);
            }
            setFetchChannels((prev) => !prev);
        } catch (error) {
            Utils.showMessage('error', error?.response?.data?.message || 'Failed to delete channel');
        } finally {
            setDeleteChannelLoading(false);
        }
    };

    return (
        <Row className={`flex items-center justify-center ${loading ? 'min-h-screen' : 'max-h-screen'}`}>
            {
                loading ?
                    <Spin spinning={loading} />
                    :
                    <>
                        <Row className="w-full flex items-start flex-wrap">
                            <Col lg={6} md={6} sm={24} className="my-4">
                                <h1 className="text-xl font-semibold">Connectivity Hub</h1>
                            </Col>
                            <Col
                                lg={18}
                                md={18}
                                sm={24}
                                className="flex justify-end items-center py-3 gap-4 flex-wrap"
                            >
                                {/* <TextField.Basic
                                    placeholder="Search here"
                                    suffix={<IoIosSearch />}
                                    className="w-8/12 py-3"
                                    value={searchText}
                                    onChange={(e) => {
                                        setSearchText(e.target.value);
                                        setStartIndex(0);
                                    }}
                                /> */}
                                {/* <Button.Basic
                                    text="Create Channel"
                                    buttonStyle={{
                                        backgroundColor: colorPrimary,
                                        color: Colors.White,
                                    }}
                                    className={'flex items-center gap-2'}
                                    size="large"
                                    icon={<FaCirclePlus color="white" className="h-4 w-4" />}
                                    onClick={() => openDrawer()}
                                /> */}
                                <UserAddnEditDrawer
                                    drawerStates={drawerStates}
                                    onCloseDrawer={onCloseDrawer}
                                    setImageValue={setImageValue}
                                    imageValue={imageValue}
                                    // setReadFile={setReadFile}
                                    // setimg={setimg}
                                    users={[]}
                                    onButtonClick={handleButtonClick}
                                    setFetchChannels={setFetchChannels}
                                />
                                {scrn.lg ? null : (
                                    <div className="py-3 px-3 rounded-md aspect-square bg-white shadow-lg">
                                        <Button.Basic
                                            onClick={() =>
                                                dispatch(AppAction.ToggleSidebar())
                                            }
                                        >
                                            <FaBars />
                                        </Button.Basic>
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <div className="flex w-full bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden" style={{ height: '83vh' }}>
                            {/* Left Sidebar */}
                            <div className="w-1/4 flex flex-col border-r border-gray-200 bg-white">
                                <div className="p-4 border-b border-gray-200 bg-gray-50 flex flex-col gap-3 shrink-0">
                                    {/* <div className="font-semibold text-lg text-gray-700">Hubs</div> */}
                                    <div className="flex items-center gap-2">
                                        <Input
                                            prefix={<IoIosSearch className="text-gray-400" />}
                                            placeholder="Search hubs..."
                                            value={hubSearchText}
                                            onChange={(e) => setHubSearchText(e.target.value)}
                                            className="rounded-full"
                                        />
                                        <Tooltip title="Create Channel">
                                            <Button.Basic
                                                buttonStyle={{
                                                    backgroundColor: colorPrimary,
                                                    color: Colors.White,
                                                }}
                                                className="flex items-center justify-center shrink-0 rounded-full"
                                                icon={<FaCirclePlus color="white" className="h-4 w-4" />}
                                                onClick={() => openDrawer()}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="flex-1 overflow-y-auto">
                                    {error && <p className="text-red-500 p-4">{error}</p>}
                                    {filteredData?.filter(g => (g?.name || `Group ${g.id}`).toLowerCase().includes(hubSearchText.toLowerCase()))?.length == 0 ? (
                                        <p className="p-4 text-gray-500">No Groups available.</p>
                                    ) : (
                                        <div className="flex flex-col">
                                            {filteredData?.filter(g => (g?.name || `Group ${g.id}`).toLowerCase().includes(hubSearchText.toLowerCase())).map((group) => (
                                                <div
                                                    key={group.id}
                                                    onClick={() => handleChatClick(group.id)}
                                                    className={`relative flex items-center p-3 gap-3 cursor-pointer border-b border-gray-100 group transition-colors ${selectedChatId === group.id
                                                        ? 'bg-blue-50'
                                                        : 'hover:bg-gray-50'
                                                        }`}
                                                >
                                                    <div className="w-12 h-12 rounded-full flex items-center justify-center text-xl text-white font-bold shrink-0" style={{ backgroundColor: colorPrimary }}>
                                                        {group.name?.charAt(0)?.toUpperCase()}
                                                    </div>
                                                    <div className="flex flex-col items-start justify-center flex-1 overflow-hidden">
                                                        <p
                                                            className="text-base font-semibold text-gray-800 w-full"
                                                            title={group.name || `Group ${group.id}`}
                                                        >
                                                            {group.name ? (group.name.length > 12 ? `${group.name.substring(0, 12)}...` : group.name) : `Group ${group.id}`}
                                                        </p>
                                                    </div>
                                                    {/* Edit / Delete icons */}
                                                    <div
                                                        className="absolute top-1/2 -translate-y-1/2 right-3 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-white/80 p-1 rounded"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <button
                                                            className="p-1.5 rounded-full hover:bg-gray-200 transition-colors"
                                                            title="Edit channel"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setEditChannelData(group);
                                                                setEditChannelName(group.name || '');
                                                                setEditChannelReadFile('');
                                                                setEditChannelMediaID(null);
                                                                setEditChannelModal(true);
                                                            }}
                                                        >
                                                            <FaPen size={12} color={colorPrimary} />
                                                        </button>
                                                        <button
                                                            className="p-1.5 rounded-full hover:bg-red-100 transition-colors"
                                                            title="Delete channel"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setDeleteChannelId(group.id);
                                                                setDeleteChannelModal(true);
                                                            }}
                                                        >
                                                            <FaTrash size={12} color={Colors.Error} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Right Chat Area */}
                            <div className="w-3/4 flex flex-col bg-[#efeae2] relative h-full">
                                {selectedChatId ? (
                                    <>
                                        {/* Chat Header */}
                                        <div className="h-16 px-4 py-2 border-b border-gray-200 bg-gray-50 flex justify-between items-center shrink-0">
                                            <div className="flex items-center gap-3 flex-1 min-w-0">
                                                <div className="w-10 h-10 rounded-full flex items-center justify-center text-lg text-white font-bold shrink-0" style={{ backgroundColor: colorPrimary }}>
                                                    {data.find(g => g.id === selectedChatId)?.name?.charAt(0)?.toUpperCase()}
                                                </div>
                                                <h2 className="text-lg font-semibold text-gray-800 whitespace-nowrap overflow-hidden text-ellipsis mr-4">
                                                    {data.find(g => g.id === selectedChatId)?.name || 'Group Chat'}
                                                </h2>
                                            </div>
                                            <div className="flex items-center gap-3 shrink-0">
                                                <Input
                                                    prefix={<IoIosSearch className="text-gray-400" />}
                                                    placeholder="Search messages..."
                                                    value={chatSearchText}
                                                    onChange={(e) => setChatSearchText(e.target.value)}
                                                    className="rounded-full w-48"
                                                />
                                                <button
                                                    className="p-2 rounded-full hover:bg-gray-200 transition-colors flex items-center justify-center"
                                                    title="View Members"
                                                    onClick={() => setShowMembersModal(true)}
                                                >
                                                    <FaUsers size={20} color={colorPrimary} />
                                                </button>
                                                <button
                                                    className="p-2 rounded-full hover:bg-gray-200 transition-colors flex items-center justify-center"
                                                    title="Add User"
                                                    onClick={() => {
                                                        setShowModal(true);
                                                        setRefresh(!refresh);
                                                    }}
                                                >
                                                    <FaUserPlus size={20} color={colorPrimary} />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Chat Messages */}
                                        <div className="flex-1 overflow-y-auto p-4 space-y-3 flex flex-col">
                                            {chatLoading ? (
                                                <div className="flex justify-center items-center h-full">
                                                    <Spin spinning={chatLoading} size="large" />
                                                </div>
                                            ) : chatMessages.filter(m => m.message?.toLowerCase().includes(chatSearchText.toLowerCase())).length > 0 ? (
                                                chatMessages.filter(m => m.message?.toLowerCase().includes(chatSearchText.toLowerCase())).map((msg, index) => {
                                                    const isMe = msg.userId === myUserId;
                                                    return (
                                                        <div key={index} className={`flex ${isMe ? 'justify-end' : 'justify-start'} w-full`}>
                                                            <div
                                                                className={`max-w-[70%] rounded-lg p-2 shadow-sm relative ${isMe ? 'bg-[#d9fdd3] rounded-tr-none' : 'bg-white rounded-tl-none'}`}
                                                            >
                                                                {!isMe && (
                                                                    <p
                                                                        className="text-[11px] font-bold mb-1 text-blue-500 cursor-pointer hover:underline"
                                                                        onClick={() => handleSenderClick(msg)}
                                                                    >
                                                                        {msg?.messageSenderName}
                                                                    </p>
                                                                )}
                                                                {msg?.message && (
                                                                    <p className="text-sm text-gray-800 break-words whitespace-pre-wrap">
                                                                        {msg?.message}
                                                                    </p>
                                                                )}
                                                                {msg?.messageImage && (
                                                                    <div className="mt-2 rounded-md overflow-hidden">
                                                                        <img
                                                                            src={msg?.messageImage}
                                                                            alt="Uploaded"
                                                                            className="max-w-full h-auto"
                                                                            style={{ maxHeight: '250px', objectFit: 'contain' }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className="text-[10px] text-gray-500 text-right mt-1 ml-4 inline-block float-right">
                                                                    {new Date(msg?.messageDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                                </div>
                                                                <div className="clear-both"></div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="flex justify-center items-center h-full">
                                                    <div className="bg-white/80 px-4 py-2 rounded-full text-sm text-gray-500 shadow-sm">
                                                        Start Conversation
                                                    </div>
                                                </div>
                                            )}
                                            <div ref={messagesEndRef} />
                                        </div>

                                        {/* Chat Input */}
                                        <div className="p-3 bg-gray-50 flex items-center gap-2 border-t border-gray-200 shrink-0">
                                            <button
                                                className="p-2 rounded-full hover:bg-gray-200 transition-colors text-gray-500"
                                                title="Attach file"
                                                disabled={isUploading}
                                                onClick={() => document.getElementById('file-input').click()}
                                            >
                                                {isUploading ? <Spin size="small" /> : <FaPaperclip size={20} />}
                                            </button>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }}
                                                id="file-input"
                                            />
                                            {selectedFile && (
                                                <div className="relative shrink-0">
                                                    <img
                                                        src={URL.createObjectURL(selectedFile)}
                                                        alt="Selected"
                                                        className="w-10 h-10 object-cover rounded border border-gray-300"
                                                    />
                                                    <button
                                                        onClick={() => {
                                                            setSelectedFile(null);
                                                            setMediaID(null);
                                                            document.getElementById('file-input').value = '';
                                                        }}
                                                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs shadow-md"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            )}
                                            <input
                                                type="text"
                                                placeholder="Type a message"
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && (message.trim() || mediaID)) {
                                                        handleMessageSend();
                                                    }
                                                }}
                                                className="flex-1 border-none rounded-full px-4 py-2 focus:outline-none focus:ring-1 focus:ring-gray-300 bg-white"
                                            />
                                            <button
                                                disabled={isUploading || (!message.trim() && !mediaID)}
                                                onClick={handleMessageSend}
                                                className={`p-2 rounded-full transition-colors flex items-center justify-center ${(!message.trim() && !mediaID) ? 'text-gray-400 bg-transparent' : 'bg-[#00a884] text-white hover:bg-[#008f6f]'}`}
                                            >
                                                <IoSend size={20} className={(!message.trim() && !mediaID) ? '' : 'ml-1'} />
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="flex flex-col justify-center items-center h-full text-gray-500 bg-gray-50">
                                        <div className="w-24 h-24 mb-4 rounded-full bg-gray-200 flex items-center justify-center">
                                            <MdGroups size={48} className="text-gray-400" />
                                        </div>
                                        <h3 className="text-xl font-light text-gray-600">Connectivity Hub</h3>
                                        <p className="text-sm mt-2">Select a group to start messaging</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
            }

            {/* Modal for Add User */}
            <Modal
                title="Add Users"
                open={showModal}
                onCancel={() => {
                    setShowModal(false); // Close the modal
                    setSelectedUsers([]); // Clear the selected users
                    setFiltersParams({
                        ...filtersParams,
                        search: '',
                        page: 1,
                        perPage: 10,
                        total: 0
                    })
                }}
                footer={null}
                width={400}
                centered
            >
                <div className="space-y-4">
                    {/* Search Bar */}
                    <Input
                        placeholder="Search users by name"
                        value={filtersParams?.search}
                        onChange={(e) =>
                            // setSearchText(e.target.value)
                            setFiltersParams((prev) => ({ ...prev, search: e?.target?.value, page: 1 }))
                        } // Update searchText state
                        className="mb-4"
                    />

                    {/* User List */}
                    <div className="text-sm">Select users to add:</div>
                    {
                        usersListingLoader &&
                        <Spin />
                    }
                    {!usersListingLoader && filteredUsersState?.length > 0 ? (
                        filteredUsersState.map((user) => (
                            <div
                                key={user.value}
                                className="flex items-center"
                            >
                                <Checkbox
                                    checked={selectedUsers.includes(
                                        user.value,
                                    )}
                                    onChange={() =>
                                        handleUserSelection(user.value)
                                    }
                                />
                                <span className="ml-2">
                                    {user.label}
                                </span>
                            </div>
                        ))
                    ) : (
                        <p>No users found.</p>
                    )}
                    {
                        filteredUsersState?.length > 0 &&
                        <div className='flex items-center justify-center py-4'>
                            <Pagination.Basic
                                total={filtersParams.total}
                                current={filtersParams.page}
                                pageSize={filtersParams.perPage}
                                onChange={paginationHandler}
                            />
                        </div>
                    }

                    {/* Add Button */}
                    <div className="mt-4 text-right">
                        <Button.Basic
                            text={'Add'}
                            type="primary"
                            loader={addUsersLoading}
                            onClick={handleAddUsers}
                            className=" text-white"
                            style={{ backgroundColor: colorPrimary }}
                        ></Button.Basic>
                    </div>
                </div>
            </Modal>

            {/* Modal for Group Members */}
            <Modal
                title="Group Members"
                open={showMembersModal}
                onCancel={() => setShowMembersModal(false)}
                footer={null}
                width={400}
                centered
            >
                <div className="space-y-3 max-h-96 overflow-y-auto">
                    {currentChannelUsers?.length > 0 ? (
                        currentChannelUsers.map((groupUser) => {
                            const member = groupUser?.member;
                            const fullName = [member?.firstName, member?.lastName].filter(Boolean).join(' ') || member?.email || 'Unknown';
                            return (
                                <div key={member?.id || groupUser?.id} className="flex items-center gap-3">
                                    <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm text-white font-bold shrink-0" style={{ backgroundColor: colorPrimary }}>
                                        {member?.profileImg?.[0]?.url ? (
                                            <img src={member.profileImg[0].url} alt={fullName} className="w-full h-full object-cover rounded-full" />
                                        ) : (
                                            fullName.charAt(0)?.toUpperCase()
                                        )}
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-medium text-gray-800 truncate">{fullName}</p>
                                        {member?.email && (
                                            <p className="text-xs text-gray-400 truncate">{member.email}</p>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p className="text-sm text-gray-500">No members found.</p>
                    )}
                </div>
            </Modal>

            {/* Edit Channel Modal */}
            <Modal
                title="Edit Channel"
                open={editChannelModal}
                onCancel={() => {
                    setEditChannelModal(false);
                    setEditChannelData(null);
                    setEditChannelReadFile('');
                    setEditChannelMediaID(null);
                }}
                footer={null}
                width={420}
                centered
            >
                <div className="space-y-4 pt-2">
                    {/* Image upload */}
                    {/* <div className="flex flex-col items-center">
                        <div className="relative w-16 h-16 rounded-full border border-gray-200 bg-gray-50 overflow-hidden cursor-pointer">
                            <input
                                type="file"
                                accept=".png,.jpg,.jpeg"
                                onChange={handleEditChannelFileChange}
                                className="absolute inset-0 w-full h-full opacity-0 z-10 cursor-pointer"
                            />
                            {editChannelReadFile ? (
                                <img
                                    src={editChannelReadFile}
                                    alt="preview"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center">
                                    <FaPen size={18} color={colorPrimary} />
                                </div>
                            )}
                            {editChannelIsUploading && (
                                <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-20">
                                    <Spin size="small" />
                                </div>
                            )}
                        </div>
                        <p className="text-xs text-gray-400 mt-1">Click to change image</p>
                    </div> */}

                    {/* Channel name */}
                    <div>
                        <label className="text-sm font-medium block mb-1">Channel Name</label>
                        <Input
                            value={editChannelName}
                            onChange={(e) => setEditChannelName(e.target.value)}
                            placeholder="Channel name (10–80 chars)"
                            minLength={10}
                            maxLength={80}
                        />
                    </div>

                    <div className="text-right pt-2">
                        <Button.Basic
                            text="Save"
                            loader={editChannelLoading || editChannelIsUploading}
                            onClick={handleEditChannel}
                            className="text-white border-none"
                            style={{ backgroundColor: colorPrimary }}
                        />
                    </div>
                </div>
            </Modal>

            {/* Delete Channel Confirmation Modal */}
            <Modal
                title="Delete Channel"
                open={deleteChannelModal}
                onCancel={() => {
                    setDeleteChannelModal(false);
                    setDeleteChannelId(null);
                }}
                footer={null}
                width={380}
                centered
            >
                <div className="py-2">
                    <p className="text-sm text-gray-600 mb-6">
                        Are you sure you want to delete this channel? This action cannot be undone.
                    </p>
                    <div className="flex justify-end gap-3">
                        <Button.Basic
                            text="Cancel"
                            onClick={() => {
                                setDeleteChannelModal(false);
                                setDeleteChannelId(null);
                            }}
                            className="h-9 px-5 border rounded"
                            style={{ background: 'transparent', color: colorPrimary, border: `1px solid ${colorPrimary}` }}
                        />
                        <Button.Basic
                            text="Delete"
                            loader={deleteChannelLoading}
                            onClick={handleDeleteChannel}
                            className="h-9 px-5 border-none text-white"
                            style={{ backgroundColor: Colors.Error }}
                        />
                    </div>
                </div>
            </Modal>

        </Row>
    );
};

export default ConnectivityHuboard;
